// extracted by mini-css-extract-plugin
export default {"imgCenter":"style_imgCenter__BAzEF","sliderBox":"style_sliderBox__a9Py2","SliderText":"style_SliderText__xeyQp"};